import Grid from '../components/grid'
import React, { ReactElement } from 'react'
import Container from '../components/ui/container'
import cn from 'classnames'
import { RichText } from '../v2/components/RichText'

// TODO: props

function MessageDarkHighlight({ text, options }: any): ReactElement {
  const { backgroundColor } = options
  return (
    <Container>
      <Grid>
        <div
          className={cn(`col-span-full p-4 text-left md:px-2.5 md:py-2 lg:px-4 lg:py-3`, {
            'bg-black text-white': backgroundColor === 'black',
            'bg-telesoft text-black': backgroundColor === 'blue',
          })}
        >
          <RichText content={text} />
        </div>
      </Grid>
    </Container>
  )
}

export default MessageDarkHighlight
